import { el } from "./dom.js";
import { BUILT_IN_PROFILES } from "../profiles/index.js";
import { state, findProfile } from "../state.js";

export function profileSelect({ id, label, value, onChange }) {
  const select = el("select", { id },
    el("optgroup", { label: "Built-in profiles" }, BUILT_IN_PROFILES.map((p) => el("option", { value: p.id }, p.name))),
    state.demoProfile
      ? el("optgroup", { label: "Demo" }, el("option", { value: state.demoProfile.id }, state.demoProfile.name))
      : null,
    state.customs.length
      ? el("optgroup", { label: "Your saved profiles" }, state.customs.map((p) => el("option", { value: p.id }, p.name)))
      : null);
  select.value = value;
  if (select.value !== value) select.value = BUILT_IN_PROFILES[0].id;
  const description = el("p", { class: "hint", id: `${id}-hint` });
  const describe = () => (description.textContent = findProfile(select.value)?.description || "");
  select.setAttribute("aria-describedby", description.id);
  select.addEventListener("change", () => {
    describe();
    onChange(select.value);
  });
  describe();
  return { wrapper: el("div", { class: "field" }, el("label", { for: id }, label), select, description), select };
}
